import {Editor} from '@tiptap/react';
import React, {FC, useState} from 'react';

import {InputDialog} from '../../../../../../../src/components/common/dialogs/inputDialog';
import {sanitizeHrefInput} from '../../../../../../shared/helpers/src/browser/urlHelpers';
import {Trans} from '../../../../../../shared/helpers/src/internationalization/react';
import {ToolbarButton} from '../../../../../../shared/ui/src/components/buttons/toolbarButton';
import {useUserTheme} from '../../../../../../shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface ImageButtonProps {
  editor: Editor;
}

/*
 * Component.
 */

export const ImageButton: FC<ImageButtonProps> = ({editor}) => {
  const theme = useUserTheme();
  const [isShowingImageUrlDialog, showImageUrlDialog] = useState(false);

  const setImageUrl = (value: string) => {
    // returns empty string if invalid
    const url = sanitizeHrefInput(value);

    if (url) {
      editor.chain().focus().setImage({src: url}).run();
    }

    showImageUrlDialog(false);
  };

  return (
    <>
      {isShowingImageUrlDialog && (
        <InputDialog
          title={<Trans id="knowledge-base-editor-image-dialog-title">Insert inline image</Trans>}
          onValueSelect={setImageUrl}
          onRequestClose={() => showImageUrlDialog(false)}
          label={<Trans id="knowledge-base-editor-image-dialog-label">Paste an image URL</Trans>}
        />
      )}

      <ToolbarButton
        iconName="formattingImage"
        label={<Trans id="knowledge-base-editor-image-button-label">Insert inline image</Trans>}
        shouldPreventMouseDown
        onClick={() => showImageUrlDialog(true)}
        color={theme.greys.shade80}
        hoverColor={theme.greys.shade80}
      />
    </>
  );
};
